import { render } from "./MediaVideo.vue?vue&type=template&id=88978408"
import script from "./MediaVideo.vue?vue&type=script&lang=js"
export * from "./MediaVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__